webpackJsonp([15],{

/***/ "./advisory-board.js":
/***/ (function(module, exports) {


window.aboundShowBoardMember = function (clickEvent) {
    var hideOverlay = function hideOverlay(overlayEl) {
        document.body.classList.remove('noscroll');
        overlayEl.remove();
    };

    var showOverlay = function showOverlay(fullMemberEl) {
        var overlay = document.createElement('div');
        overlay.classList.add('overlay');
        overlay.addEventListener('click', function (_ref) {
            var currentTarget = _ref.currentTarget;

            hideFullMember(fullMemberEl);
            hideOverlay(currentTarget);
        });
        document.body.classList.add('noscroll');
        document.body.appendChild(overlay);
        return overlay;
    };

    var showFullMember = function showFullMember(fullMemberEl) {
        return fullMemberEl.style.display = 'block';
    };
    var hideFullMember = function hideFullMember(fullMemberEl) {
        return fullMemberEl.style.display = 'none';
    };

    var selectorMatches = function selectorMatches(el, selector) {
        var p = Element.prototype;
        var f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function (s) {
            return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };
        return f.call(el, selector);
    };

    var getParent = function getParent(selector, el) {
        var p = el.parentNode;
        while (!selectorMatches(p, selector)) {
            p = p.parentNode;
        }return selectorMatches(p, selector) ? p : undefined;
    };

    var clickEl = clickEvent.target;
    var memberEl = getParent('.member', clickEl);
    var fullMemberEl = memberEl.querySelector('.full-member');
    var closeEl = fullMemberEl.querySelector('.close');

    var onClickClose = function onClickClose(overlayEl) {
        return function (_ref2) {
            var currentTarget = _ref2.currentTarget;

            currentTarget.removeEventListener('click', onClickClose);
            hideFullMember(fullMemberEl);
            hideOverlay(overlayEl);
        };
    };

    showFullMember(fullMemberEl);
    var overlayEl = showOverlay(fullMemberEl);
    closeEl.addEventListener('click', onClickClose(overlayEl));
};

/***/ })

},["./advisory-board.js"]);


// WEBPACK FOOTER //
// scripts/advisory-board.d075e11b60a6b8e95314.js